/**
 * Cart object for handling shopping cart operations.
 * @namespace
 */
const getStorefrontToken = () => {
  const host = window.location.hostname;
  
  const isDev = host.includes("localhost") || 
                host.includes("127.0.0.1") || 
                host.includes("xn-48j0eoa4265c.myshopify.com"); 

  return isDev 
    ? "7517fbbac6c6500d6de611935256ed18"  
    : "fe99d09e862d495a0bbd5e9f1f18576b"; 
};

const STOREFRONT_TOKEN = getStorefrontToken();

const Cart = {
  /**
   * Add an item to the cart.
     *
     * @async
     * @function
     * @param {number} id - The ID of the item to add.
     * @param {number} quantity - The quantity of the item to add.
     * @returns {Promise<object>} A Promise that resolves to the response data or rejects with an error.
   */
  addToCart: async (id, quantity) => {
    try {
      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          id: id,
          quantity: quantity,
        },
      });
    } catch (err) {
      return err;
    }
  },
  /**
     * Get the current contents of the cart.
     *
     * @async
     * @function
     * @returns {Promise<object>} A Promise that resolves to the cart data or rejects with an error.
   */
  getCart: async () => {
    const res = await $.ajax({
      type: "GET",
      url: "/cart.js",
      dataType: "json",
    });
    return res;
  },
  /**
   * Remove an item from the cart.
     *
     * @async
     * @function
     * @param {number} id - The ID of the item to remove.
     * @returns {Promise<object>} A Promise that resolves to the response data or rejects with an error.
   */
  removeFromCart: async (id) => {
    let data = {
      id: id,
      quantity: 0,
    };
    try {
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: data,
      });
    } catch (err) {
      return err;
    }
  },
  /**
   * Update the quantity of an item in the cart.
   *
   * @async
   * @function
   * @param {number} id - The ID of the item to update.
   * @param {number} quantity - The new quantity of the item.
   * @returns {Promise<object>} A Promise that resolves to the response data or rejects with an error.
   */
  updateFromCart: async (id, quantity) => {
    try {
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: id,
          quantity: quantity,
        },
      });
    } catch (err) {
      return err;
    }
  },
  /**
   * Clear all product of the cart.
   *
   */
  clearCart: () => {
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      success: function (res) {
        console.log(res);
        return res;
      },
      error: function (err) {
        console.log(err);
      },
    });
  },
  /**
   * Update the cart item count displayed in the sidebar.
   * 
   */
  updateCartCount: async () => {
    const currentCart = await Cart.getCart();
    $("#side_bar .cart").attr("data-cart", currentCart.item_count);
    if (currentCart.item_count > 0) {
      $(".sp_cart").removeClass("empty");
      $(".sp_cart").attr("data-cart", currentCart.item_count);
    } else {
      $(".sp_cart").addClass("empty");
      $(".sp_cart").removeAttr("data-cart");
    }
    return currentCart.items;
  },
};
const Product = {
  /**
         * Convert a product ID to a Shopify GID format.
         * @param {number} id - The product ID.
         * @return {string} - The Shopify GID string.
         */
  idToGid: (id) => {
    return `gid://shopify/Product/${id}`;
  },
  gidToId: (gid) =>{
    return gid.split('/').pop();
  },

  formatPrice: (price) => {
    return (Number(price) / 100).toLocaleString();
  },

  /**
   * Get recommended products based on a given product ID.
   * @param {number} id - The product ID.
   * @param {number} limit - The number of recommended products to retrieve.
   * @param {"related" | "complementary"} intent - The type of recommendation, either "related" or "complementary".
   * @returns {Promise} - A promise that resolves to the recommended products data.
   */
  getRecommendedProducts: async (id, limit, intent) => {
    const query = `query getRecommendations($id: ID!) {
      productRecommendations(productId: $id) {
        id
        title
        onlineStoreUrl
        handle
        images(first: 1) {
              nodes {
                url
              }
        }
        variants(first: 250) {
              nodes {
                id
                price {
                  amount
                  currencyCode
                }
              }
        }
        metafields(
              identifiers: [{namespace: "custom", key: "location"}, {namespace: "custom", key: "store_name"}]
        ) {
          key
          value
          namespace
        }
      }
    }`;
    const variables = {
      id: Product.idToGid(id),
    };
    const response = await GraphQL.fetch(query, variables);
    return response.productRecommendations;
  },
  getProductWithMeta: async (id) => {
    const query = `query getProductWithMeta($id: ID!) {
      product(id: $id) {
        id
        title
        onlineStoreUrl
        handle
          images(first: 1) {
            nodes {
              url
            }
          }
        variants(first: 250) {
              nodes {
                id
                price {
                  amount
                  currencyCode
                }
              }
        }
        metafields(
            identifiers: [{namespace: "custom", key: "location"}, {namespace: "custom", key: "store_name"}]
        ) {
          key
          value
          namespace
        }
      }
    }`;
    const variables = {
      id: Product.idToGid(id),
    };
    const response = await GraphQL.fetch(query, variables);
    return response;
  },
  getProductByHandle: async (handle) => {
    const query = `
      query getProductByHandle($handle: String!) {
        productByHandle(handle: $handle) {
          id
          title
          onlineStoreUrl
          handle
          images(first: 1) {
            nodes {
              url
            }
          }
          variants(first: 2) {
            nodes {
              id
              price {
                amount
                currencyCode
              }
            }
          }
          metafields(
            identifiers: [
              {namespace: "custom", key: "location"}, 
              {namespace: "custom", key: "store_name"}
            ]
          ) {
            key
            value
            namespace
          }
        }
      }
    `;
  
    const variables = { handle };
  
    const response = await GraphQL.fetch(query, variables);
    return response.productByHandle;
  },
  getVariants: async (handle) => {
    const query = `
      query getProductByHandle($handle: String!) {
        productByHandle(handle: $handle) {
          variants(first: 100) {
            nodes {
              id
              title
              availableForSale
              quantityAvailable
              currentlyNotInStock
            }
          }
        }
      }
    `;
  
    const variables = { handle };
  
    const response = await GraphQL.fetch(query, variables);
    return response.productByHandle?.variants?.nodes || [];
  },
  
  /**
   * Find a product variant based on given options.
   * @param {object} options - The options to match against product variants.
   * @return {object|undefined} - The matching product variant or undefined if not found.
   * @example : findVariant({option1: 'Red', size: 'M'})
   */

  findVariant: (seclectedArr, prdVariantArr) => {
    return prdVariantArr.find(variant =>
      variant.options.every((value, index) => value === seclectedArr[index])
    );
  },

};
const Article = {
  getArticleByHandle: async (blogHandle, articleHandle) => {
    const query = `query getArticleByHandle($blogHandle: String!, $articleHandle: String!) {
        blogByHandle(handle: $blogHandle) {
          id
          title
          articleByHandle(handle: $articleHandle) {
            id
            title
            handle
            publishedAt
            contentHtml
            excerpt
            excerptHtml
            tags
            seo {
              title
              description
            }
            image {
              url
              altText
            }
            author {
              name
              email
            }
          }
        }
      }
      `;
    const variables = {
      blogHandle: blogHandle,
      articleHandle: articleHandle,
    };
    const response = await GraphQL.fetch(query, variables);
    return response;
  },
}
const GraphQL = {
  /**
   * Fetch data from Shopify's GraphQL API.
   * @param {string} query - The GraphQL query string.
   * @param {object} variables - The variables for the GraphQL query.
   * @return {Promise<object|null>} - The product data or null if an error occurs.
   * 
   * */
  fetch: async (query, variables) => {
    try {
      const response = await $.ajax({
        type: 'POST',
        url: `https://${SHOP_DOMAIN}/api/2025-10/graphql.json`,
        contentType: 'application/json',
        dataType: 'json',
        headers: {
          'Accept': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        data: JSON.stringify({
          query,
          variables,
        }),
      });
      if (response?.errors) {
        // cache last errors for downstream consumers to show a better message
        window.__lastGraphQLErrors = response.errors;
        console.error('GraphQL Response Errors:', response.errors);
      } else {
        window.__lastGraphQLErrors = null;
      }
      return response?.data || null;

    } catch (error) {
      // Try to parse and cache transport-level errors for better UX
      try {
        const respJSON = error?.responseJSON || (error?.responseText ? JSON.parse(error.responseText) : null);
        const errors = respJSON?.errors || null;
        window.__lastGraphQLErrors = errors || [{ message: (respJSON?.message || 'Network/Server error') }];
      } catch (_) {
        window.__lastGraphQLErrors = [{ message: 'Network/Server error' }];
      }
      console.error('GraphQL Error:', error.responseText || error);
      return null;
    }
  }
}
const Utils = {
  debounce(func, wait, immediate = false) {
    let timeout;

    return function (...args) {
      const context = this;

      const callNow = immediate && !timeout;

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);

      if (callNow) func.apply(context, args);
    };
  },

  throttle(func, wait) {
    let lastTime = 0;
    let timeout = null;

    return function (...args) {
      const context = this;
      const now = Date.now();
      const remaining = wait - (now - lastTime);

      if (remaining <= 0) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        lastTime = now;
        func.apply(context, args);
      } else if (!timeout) {
        timeout = setTimeout(() => {
          lastTime = Date.now();
          timeout = null;
          func.apply(context, args);
        }, remaining);
      }
    };
  },
  onElementAppear(selector, callback, root = document.body)  {
    const observer = new MutationObserver((mutations, obs) => {
      if ($(selector).length) {
        callback($(selector));
        obs.disconnect();
      }
    });
  
    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }
};

// Patch to intercept fetch requests, mostly for app like also bought. Feel free to improve it.
function interceptFetch(targetUrl, callback) {
  function applyPatch() {
    if (!window.fetch) {
      // Retry until fetch is available
      setTimeout(applyPatch, 50);
      return;
    }

    const originalFetch = window.fetch;
    if (originalFetch._intercepted) return; // avoid double patching

    window.fetch = async (...args) => {
      const url = args[0];

      if (typeof url === 'string' && url.includes(targetUrl)) {

        const response = await originalFetch(...args);
        const clone = response.clone();

        clone
          .json()
          .then(data => callback(data, url))
          .catch(() => clone.text().then(text => callback(text, url)));

        return response;
      }

      return originalFetch(...args);
    };

    // Mark as patched
    window.fetch._intercepted = true;
  }

  // Try immediately
  applyPatch();
}
function observeAlsoBoughtAndGetProducts() {
  return new Promise(resolve => {
    const process = async container => {
      if (container.dataset.processed) return;
      container.dataset.processed = 'true';

      const handles = Array.from(
        container.querySelectorAll('.cbb-also-bought-product-name a[href]')
      ).map(a =>
        a.getAttribute('href').replace(/\/$/, '').split('/').pop()
      );

      const products = await Promise.all(
        handles.map(handle => Product.getProductByHandle(handle))
      );

      resolve(products);
    };

    // Already existed
    const existing = document.querySelector('.cbb-also-bought-container');
    if (existing) {
      process(existing);
      return;
    }

    // Observe when not existed
    const observer = new MutationObserver((_, obs) => {
      const container = document.querySelector('.cbb-also-bought-container');
      if (container) {
        obs.disconnect();
        process(container);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
}

function handleModal(message, type = "info", _duration = 3000) {
  const modal = $('#modal');
  modal.find('.modal_content').text(message);
  modal.fadeIn(200);

  setTimeout(() => {
    modal.fadeOut(200);
  }, _duration);

}

// Swym APIが利用可能になるまで待機
function waitForSwym(callback, maxAttempts = 100) {
  let attempts = 0;
  const checkSwym = setInterval(() => {
    attempts++;
    if (typeof _swat !== 'undefined' && _swat.wishlist && _swat.wishlist.fetchUserLists && _swat.fetchListCtx) {
      clearInterval(checkSwym);
      callback();
    } else if (attempts >= maxAttempts) {
        clearInterval(checkSwym);
    }
  }, 100);
}
// --------------------------------------------------
    // data-cartバッジを更新
    // --------------------------------------------------
    async function updateCartBadge() {
      try {
          const cart = await (await fetch("/cart.js")).json();
          const $cartLink = $(".tlt_item.cart");
          if ($cartLink.length) {
              $cartLink.attr("data-cart", cart.item_count).toggleClass("has-item", cart.item_count > 0);
              $(".sp_cart").removeClass("empty");
              $(".sp_cart").attr("data-cart", cart.item_count);
          }
             else {
              $(".sp_cart").addClass("empty");
              $(".sp_cart").removeAttr("data-cart");
             }
      } catch (err) {
          console.error("updateCartBadge error:", err);
      }
  }